import * as actions from './slice'

export const listSkillBites = {
  eventName: 'skillBiteList',
  onSuccess: {
    action: actions.setSkillBites,
    redux: true
  }
}

export const listSkillBitesBySkills = ({ onSuccess, onError }) => ({
  eventName: 'skillBiteListBySkills',
  onSuccess,
  onError
})

export const getSkillBiteLanguages = {
  eventName: 'getSkillBiteLanguages',
  onSuccess: {
    action: actions.setSkillBiteLanguages,
    redux: true
  }
}

export const subscribeUser = ({ onSuccess, onError }) => {
  return {
    eventName: 'skillBiteSubscribeUser',
    onSuccess: [
      { action: actions.setSkillBiteSubscription, redux: true },
      onSuccess
    ],
    onError
  }
}

export const getSkillBitesSubscriptions = {
  eventName: 'skillBiteGetSubscriptions',
  onSuccess: {
    action: actions.setSkillBitesSubscriptions,
    redux: true
  }
}
